import { render } from "./NewRepairPart.vue?vue&type=template&id=128e35f6"
import script from "./NewRepairPart.vue?vue&type=script&lang=js"
export * from "./NewRepairPart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__